import {
	FileDetailRequest,
	FileDetailResponse,
} from '../modules/claim/models/file.models';
import SendRequest from '../services/sendRequest.service';
import imageCompression from 'browser-image-compression';
import { ClaimListDetails, ClaimListRequest, ClaimListResponse } from '../modules/claim/models/claimList.models';
import { getCookieValue, postToNativeApp } from '../common/helpers';
import { GaEvent, GaPageView } from '../services/ga.service';
import toast, { ToastType } from 'react-hot-toast';
import ToastCard from '../common/components/toastCard';
import { ToastError } from '../common/models/toastError';
import { isMobile } from 'react-device-detect';
import { IBaseProfile } from '../modules/profile/Account.model';
// import GA4React from "ga-4-react";
const _ = require('lodash');
const crypto = require('crypto');

const ENC_KEY = '';
const IV = '';

// const ga4react = new GA4React(process.env.REACT_APP_GA_ID);
// let ga4 =null;

const checkAndResetTempLoginToken = async () => {
	if (localStorage.getItem('loginToken')) {
		let expTime = new Date(localStorage.getItem('loginTokenExpiryTime'))
		if (new Date() > expTime) {
			localStorage.removeItem("loginToken")
			localStorage.removeItem("loginTokenExpiryTime")
		}
	}
}

const formatDate = (date: any, IsRequriedTime: boolean = false) => {
	const formattedDate = String(date).includes('/Date(')
		? new Date(parseInt(date.replace('/Date(', '')))
		: new Date(date);
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];
	const OnlyDate = `${formattedDate.getDate()} ${monthNames[formattedDate.getMonth()]
		} ${formattedDate.getFullYear()}`;
	if (IsRequriedTime)
		return (
			' ' +
			OnlyDate +
			' ' +
			formattedDate
				.toLocaleString('en-IN', {
					hour: 'numeric',
					minute: 'numeric',
					hour12: true,
				})
				.toLocaleUpperCase()
		);
	return OnlyDate;
};

const formatePrice = (price: any) => {
	if (price)
		return `${new Intl.NumberFormat('en-IN', {
			maximumSignificantDigits: price.toString().length,
		}).format(price)}`;
	else return '0';
};

const formatAMPM = (date: any) => {
	let dateToFormat: any;
	if (String(date).includes('/Date(')) {
		dateToFormat = new Date(parseInt(date.replace('/Date(', '')));
	} else {
		dateToFormat = new Date(date);
	}
	let hours: any = dateToFormat.getHours();
	let minutes: any = dateToFormat.getMinutes();
	const ampm: string = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0' + minutes : minutes;
	return `${hours}:${minutes} ${ampm}`;
};

const isEmpty = (obj: any) => {
	return !(Object.keys(obj).length > 0);
};

const tokenExpiryTime = (timeInMs: number) => {
	const now = new Date();
	const time = now.getTime();
	const tokenExpiry = time + timeInMs;
	now.setTime(tokenExpiry);
	return now;
};

const maskInput = (
	inputStr: string,
	startFrom: number,
	fromEnd: number
): any => {
	let maskedInput: string;
	if (inputStr) {
		let maskedArray = inputStr.split('');
		for (let i = 0; i < maskedArray.length; i++) {
			if (i >= startFrom && i <= maskedArray.length - (fromEnd + 1))
				maskedArray[i] = '*';
		}
		maskedInput = maskedArray.join('');
	}
	return maskedInput;
};
const uploadFiles = async (files: []): Promise<any> => {
	let data = new FormData();
	for (let i = 0; i < files.length; i++) {
		data.append('file', await compressFile(files[i]));
	}
	const headers = {
		accessToken: localStorage.getItem('accessToken'),
		loginToken: localStorage.getItem('loginToken')
	}

	const response = await fetch(
		`${process.env.REACT_APP_API_BASE_URL}/file/upload`,
		{
			method: 'POST',
			body: data,
			headers
		}
	)
		.then((response) => response.json())
		.then((success) => {
			return success;
		})
		.catch((error) => {
		});
	const json = await response;
	return json;
};

const fetchFileDetail = async (filePath: string): Promise<string> => {
	let response = new FileDetailResponse();
	try {
		if (!filePath) {
			return response.fileURL;
		}
		let requestObject: FileDetailRequest = new FileDetailRequest();
		requestObject.filepath = filePath;
		response = await SendRequest.instance.post(
			`${process.env.REACT_APP_API_BASE_URL}/file/download`,
			requestObject
		);
		if (!response.isSuccess) {
			throw new ToastError(response.error);
		}
	} catch (error) {
		handleToast(error);
	} finally {
		return response.fileURL;
	}
};

const uploadKycDoc = async (
	files: [],
	apiPath: string,
	fileName: string
): Promise<any> => {
	let data = new FormData();
	for (let i = 0; i < files.length; i++) {
		data.append('fileName', fileName);
		data.append('file', await compressFile(files[i]));
	}
	const headers = {
		accessToken: localStorage.getItem('accessToken'),
		loginToken: localStorage.getItem('loginToken')
	}
	let start: any = Date.now();
	let end: any;
	let status;

	const response = await fetch(
		`${process.env.REACT_APP_API_BASE_URL}/${apiPath}`,
		{
			method: 'POST',
			body: data,
			headers
		}
	)
		.then((response) => response.json())
		.then((success) => {
			end = Date.now();
			status = true;
			let url = `${process.env.REACT_APP_API_BASE_URL}/${apiPath}`
			if (url.toLowerCase().includes('/kyc/')) {
				GaPageView('/signzyUpload');
			}
			return success;
		})
		.catch((error) => {
			status = false;
			end = Date.now();
		});
	GaEvent("fileUpload_fileUpload", {
		category: "fileUpload",
		action: "fileUpload",
		timeTaken: (end - start) + " ms",
		userProperty:
			JSON.stringify({
				maid: localStorage.getItem("maid"),
				UploadSuccess: status,
				timeTaken: (end - start) + " ms"
			})
	});

	const json = await response;
	return json;
};

const isFileImage = (file: any): boolean => {
	return file && file['type'].split('/')[0] === 'image';
};

const downloadFile = (filePath: string, setLoader?: Function ) => {
	setLoader?.(true);
	fetchFileDetail(filePath).then((x: any) => {
		if (!x){
			setLoader?.(false);
			return;
		} 
		let link = document.createElement('a');
		link.href = x;
		link.download = x;
		link.onclick = () => {
			setLoader?.(false);
			postToNativeApp({
				browserUrl: x
			});
		}
		link.target = '_blank';
		link.click();
	});
};

const addTimestampToUrl = (url: string): string => {
	if (url) {
		let new_url = new URL(url);
		let search_params = new_url.searchParams;
		search_params.set('dt', new Date().valueOf().toString());
		new_url.search = search_params.toString();
		return new_url.toString();
	}
};



const encrypt = (input: string) => {
	return input;
};

var decrypt = (encrypted) => {
	return encrypted;
};

const compressFile = async (file: File): Promise<any> => {
	if (file instanceof Blob === false) return file;

	try {
		if (isFileImage(file) && file.size / 1024 / 1024 > 1) {
			let options = {
				maxSizeMB: 1,
				maxWidthOrHeight: 1920,
				useWebWorker: true,
			};
			const compressedFile = await imageCompression(file, options);
			return blobToFile(compressedFile, file.name);
			//} else if (file.type === 'application/pdf' && file.size / 1024 / 1024 > 5) {
			//TODO: Compress pdf
			//  return file;
		} else {
			return file;
		}
	} catch (err) {
		return file;
	}
};
const blobToFile = (theBlob: Blob, fileName: string): File => {
	return new File([theBlob], fileName, {
		lastModified: new Date().getTime(),
		type: theBlob.type,
	});
};
const setWithExpiry = (key: string, value: any, ttl = 3600000): void => {
	//default ttl is set to 15 min
	const now = new Date();
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	};
	localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key: string) => {
	const itemStr = localStorage.getItem(key);
	if (!itemStr) {
		return null;
	}
	const item = JSON.parse(itemStr);
	const now = new Date();
	if (now.getTime() > item.expiry) {
		localStorage.removeItem(key);
		return null;
	}
	return item.value;
};

const isTimeOver = (timeStamp) => {
	let time = Date.now();
	if (time >= timeStamp) return true
	return false
}


const dateInExpiryFormat = (date) => {
	let textFormatedDate = date.split("-")
	let month = textFormatedDate[1]
	let year = textFormatedDate[0].split("")
	return (`${month}/${year[2] + year[3]}`)
}

const capitalizeFirstLetter = (word: string) => {
	const capitalized =
		word.charAt(0).toUpperCase()
		+ word.slice(1)
	return capitalized
}

const formatDateMonth = (date: any, getYear = false) => {
	const formattedDate = String(date).includes('/Date(')
		? new Date(parseInt(date.replace('/Date(', '')))
		: new Date(date);
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];
	let OnlyDate = `${formattedDate.getDate()} ${monthNames[formattedDate.getMonth()]}`;
	if (getYear)
		OnlyDate = OnlyDate + ` ${formattedDate.getFullYear()}`;

	return OnlyDate;
};
const getDomiValue = (policy) => {
	let totalDomiValue = 0
	if (policy.polFloater) {
		totalDomiValue = policy.benefDomLimit
	}
	if (!policy.polFloater) {
		policy.benefDetail.map((policy) => {
			totalDomiValue = totalDomiValue + policy.benefIndiVidualDomLimit
			return null;
		})
	}
	return totalDomiValue
}
const getPolicyTotalSumInsured = (policyDetail) => {
	let tsa = 0
	if (policyDetail.polFloater) {
		tsa = policyDetail.totalSumInsured
	}
	// if (!policyDetail.polFloater) {
	//   policyDetail.benefDetail.map((benef) => {
	//     tsa = tsa + benef.benifTSA
	//   })
	// }
	return tsa
}
const stringInPascalCase = (str: string) => {
	if (!str) return '';

	return str.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
}

const validatePassword = (str: string) => {
	return str.match(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])\S{8,15}$)/g);
}

const validateEmail = (str: string) => {
	return str.match(/^[a-z0-9]+@[a-z]+\.[a-z]{2,3}/g);
}

const validateMobileNumber = (str: string) => {
	return str.match(/^\d{10}$/);
}
const validateAccountNumber = (str: string) => {
	return str.match(/^[0-9]{9,18}$/);
}

const handleToast = (err: Error) => {
	if (err instanceof ToastError) {
		createToast(err.message);
	}
}

const createToast = (message: string, type: ToastType = "error") => {
	toast((t) => (
		<ToastCard type={type} message={message} handleDismiss={() => toast.dismiss(t.id)} />
	));
}

const getPlatform = () => {
	let platform;
	if (isMobile) {
		if (getCookieValue('platform')) {
			if (getCookieValue('platform') == 'ios') {
				platform = 'MAVEN|IOS'
			}
			else if (getCookieValue('platform') == 'android') {
				platform = 'MAVEN|ANDROID'
			}
		}
		else {
			platform = "MAVEN|MobileWeb"
		}
	} else {
		platform = 'MAVEN|Web'
	}
	return platform;
}
const getIpAdd = async () => {
	const ip = await SendRequest.instance.getExternal('https://api.ipify.org?format=json');
	return ip;
}
const gaBankDetails = (action, details) => {
	GaEvent(action, {
		category: "ProfileBankAccount",
		label: `${details.benefName}` + '_' + `${details.mediAssistId}` + '_' + `${details.policyId}`,
		userProperty:
			JSON.stringify({
				benefName: details.benefName,
				maid: details.mediAssistId,
				policyId: details.policyId,
			})
	});
}

const gaContactDetails =(action:string,contactDetails:IBaseProfile,apiResponseTime:any)=>{
  GaEvent(action, {
    category: "profileContact",
    label: `${contactDetails?.userName}`+'_'+`${contactDetails?.maid}`+'_'+`${contactDetails?.employeeId}`,
        userProperty:
        JSON.stringify({
          benefName: contactDetails?.userName,
          maid: contactDetails?.maid,
          employeeId: contactDetails?.employeeId,
          apiResponseTime: apiResponseTime + " ms"
        })
  });
}

const downloadPDFFile =(fileBytes,fileName)=>{
    if(fileBytes){
        const byteCharacters = atob(fileBytes);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        postToNativeApp({browserUrl: url });
        link.href = url;
        link.download = fileName;
        link.click(); 
    }
}

 const validateInput = (inputText: string) => {
	// Regular expression that allows any characters except ~ < > & % and restricts double dots (..)
	var regInput = new RegExp('^(?!.*\\.{2})[^~<>&%]+$');
	return regInput.test(inputText);
  }
   const replaceAccessTokenInUrl=(url:string, token:string)=> {
	return url.replace(/\[accesstoken\]/gi, encodeURIComponent(token));
}

export {
  dateInExpiryFormat,
  validateInput,
  formatDate,
  formatePrice,
  isEmpty,
  formatAMPM,
  tokenExpiryTime,
  uploadFiles,
  maskInput,
  fetchFileDetail,
  uploadKycDoc,
  isFileImage,
  downloadFile,
  addTimestampToUrl,
  encrypt,
  decrypt,
  getDomiValue,
  compressFile,
  setWithExpiry,
  getWithExpiry,
  getPolicyTotalSumInsured,
  formatDateMonth,
  stringInPascalCase,
  validatePassword,
  checkAndResetTempLoginToken,
  validateEmail,
  validateMobileNumber,
  isTimeOver,
  handleToast,
  validateAccountNumber,
  getPlatform,
  getIpAdd,
  capitalizeFirstLetter,
  gaBankDetails,
  gaContactDetails,
  downloadPDFFile,
  replaceAccessTokenInUrl
};

